module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_v_chestnut.7dd86ae8.png";